export const wordsJa = {
    kat_6: [
        "アクセサリー",
        "ウォーキング",
        "エキスパート",
        "オーケストラ",
        "キャンペーン",
        "コントロール",
        "ショッピング",
        "スウェーデン",
        "スケジュール",
        "チョコレート",
        "ドレッシング",
        "ハンドソープ",
        "バトミントン",
        "パイナップル",
        "フリーランス",
        "ブラッシング",
        "ブルドーザー",
        "ペットボトル",
        "マクドナルド",
        "マグネシウム",
    ],
    kan_1: [
        "凪",
        "坪",
        "婿",
        "宝",
        "数",
        "株",
        "獣",
        "畳",
        "癖",
        "縦",
        "蜂",
        "訳",
        "雨",
        "髪",
        "鯨",
    ], hir_2: [
        "あき",
        "あさ",
        "あめ",
        "いま",
        "かさ",
        "かに",
        "かば",
        "くさ",
        "くま",
        "くも",
        "くり",
        "さる",
        "した",
        "そら",
        "とり",
        "ねこ",
        "まど",
        "ゆき",
        "ゆび",
        "りす",
    ], kan_2: [
        "一蹴",
        "勇敢",
        "卸売",
        "参詣",
        "商魂",
        "善意",
        "威圧",
        "庭園",
        "怨恨",
        "捕鯨",
        "晴天",
        "精鋭",
        "脅威",
        "腫瘍",
        "膨張",
        "資料",
        "配布",
        "錯覚",
        "飢餓",
    ], hir_3: [
        "あくび",
        "あした",
        "おかし",
        "きつね",
        "きょう",
        "くもり",
        "くるま",
        "ことり",
        "こども",
        "さかな",
        "さくら",
        "さしみ",
        "さんぽ",
        "すいか",
        "たまご",
        "どうろ",
        "ふぶき",
        "ぼうし",
        "まなつ",
        "もぐら",
    ], kan_3: [
        "不可解",
        "刹那的",
        "向日葵",
        "好事家",
        "小学校",
        "幼稚園",
        "戒厳令",
        "放課後",
        "未曾有",
        "歌舞伎",
        "炎天下",
        "絆創膏",
        "絵巻物",
        "胃潰瘍",
        "脳梗塞",
        "蜃気楼",
        "金字塔",
        "駐在員",
    ], kat_3: [
        "アイス",
        "インク",
        "カバン",
        "コート",
        "スイス",
        "スープ",
        "ズボン",
        "タヌキ",
        "タバコ",
        "テニス",
        "トイレ",
        "ドイツ",
        "パーマ",
        "ピンク",
        "マンゴ",
        "メガネ",
        "ヨット",
        "ランプ",
        "リボン",
        "レベル",
    ], hir_4: [
        "おりがみ",
        "かみなり",
        "がっこう",
        "きゅうり",
        "きんぎょ",
        "こうよう",
        "こうろぎ",
        "しいたけ",
        "しょうゆ",
        "すずむし",
        "せっけん",
        "たまねぎ",
        "ともだち",
        "どうぶつ",
        "どらやき",
        "にわとり",
        "にんげん",
        "ふんすい",
        "ままごと",
        "まんげつ",
    ], kan_4: [
        "一期一会",
        "優柔不断",
        "品質管理",
        "因果応報",
        "土砂災害",
        "天真爛漫",
        "害虫駆除",
        "市民団体",
        "後方支援",
        "才色兼備",
        "書式設定",
        "温故知新",
        "疑心暗鬼",
        "登場人物",
        "賞味期限",
        "難攻不落",
        "難行苦行",
        "食物素材",
        "食物繊維",
    ], kat_4: [
        "アルバム",
        "エプロン",
        "エリンギ",
        "クレヨン",
        "コスモス",
        "コンソメ",
        "サンダル",
        "システム",
        "ジャンプ",
        "スタート",
        "スプーン",
        "ソックス",
        "チェック",
        "チャンス",
        "テーブル",
        "トンネル",
        "パソコン",
        "ビタミン",
        "フォーク",
        "フランス",
    ], hir_5: [
        "あかとんぼ",
        "ありがとう",
        "うろこぐも",
        "おおみそか",
        "おしながき",
        "おてつだい",
        "かきじゅん",
        "きんようび",
        "くるまいす",
        "こんにちは",
        "さくらんぼ",
        "なつまつり",
        "ぬいぐるみ",
        "ひがんばな",
        "ひなまつり",
        "ふゆやすみ",
        "むしめがね",
        "ももたろう",
        "ゆうえんち",
        "ゆきだるま",
    ], kat_5: [
        "アライグマ",
        "アンケート",
        "エネルギー",
        "クッション",
        "クラシック",
        "クリスマス",
        "クリニック",
        "コンサート",
        "サクランボ",
        "セロテープ",
        "タンバリン",
        "バスケット",
        "ピクニック",
        "プログラム",
        "プロポーズ",
        "マニキュア",
        "ミュンヘン",
        "メッセージ",
        "ヨーロッパ",
        "レストラン",
    ]
};
